import React, { useContext } from 'react'
import { TextContext } from 'hocs'
import { Indicator } from 'components/molecules/NursingIndicator/partials'
import PropTypes from 'prop-types'
import * as Styled from './IndicatorLegend.styles'

const indicatorLegendLabels = {
  square: {
    4: 'Keine oder geringe Qualitätsdefizite',
    3: 'Moderate Qualitätsdefizite',
    2: 'Erhebliche Qualitätsdefizite',
    1: 'Schwerwiegende Qualitätsdefizite',
    0: 'Konnte nicht geprüft werden',
    false: 'Mindestbewertung festlegen',
    '-1': 'Einzelfall, nicht bewertet',
    '-2': 'nicht plausible Angaben',
  },
  circle: {
    7: 'Einzelfall, nicht bewertet',
    6: 'Die Ergebnisqualität konnte nicht berechnet werden.',
    5: 'Weit über dem Durchschnitt',
    4: 'Leicht über dem Durchschnitt',
    3: 'Nahe beim Durchschnitt',
    2: 'Leicht unter dem Durchschnitt',
    1: 'Weit unter dem Durchschnitt',
    0: 'Die Ergebnisqualität konnte nicht berechnet werden.',
    false: 'Mindestbewertung festlegen',
    '-1': 'nicht plausible Angaben',
  },
}

const IndicatorLegend = ({ variant = 'circle', withDescription }) => {
  const textContext = useContext(TextContext)

  if (variant === 'square') {
    return (
      <Styled.IndicatorLegend withDescription={ withDescription }>
        {[
          // -2,
          // -1,
          ...Array(5).keys(),
        ]
          .reverse()
          .map((i) => {
            if (withDescription && i === 0) {
              return null
            }

            return (
              <div
                key={ `indicator-legend-square-${ i }` }
                className='indicator-legend-row'>
                <div className='indicator-legend-rating'>
                  <Indicator variant='square' rating={ i } />
                </div>
                <p>{indicatorLegendLabels.square[i]}</p>
                {/* no text provided yet: https://bugs.onedev.aok.de/browse/MGMPMNAV-3593 */}
                {/* {withDescription && ( */}
                {/*   <span className='indicator-legend-description'> */}
                {/*     { */}
                {/*       textContext[ */}
                {/*         `nursingIndicator.indicator.square.${ i }.description` */}
                {/*       ] */}
                {/*     } */}
                {/*   </span> */}
                {/* )} */}
              </div>
            )
          })}
      </Styled.IndicatorLegend>
    )
  }

  return (
    <Styled.IndicatorLegend withDescription={ withDescription }>
      {[...(withDescription ? [] : [-1, 7]), ...Array(6).keys()]
        .reverse()
        .map((i) => {
          if (withDescription && i === 0) {
            return null
          }

          return (
            <div
              key={ `indicator-legend-circle-${ i }` }
              className='indicator-legend-row'>
              <div className='indicator-legend-rating'>
                <Indicator rating={ i } />
              </div>
              <p>
                {withDescription &&
                  textContext[
                    'nursingIdicator.overlay.indicator.prefix.circle'
                  ]}
                {indicatorLegendLabels.circle[i]}
              </p>
              {/* withDescription && (
              <span className='indicator-legend-description'>
                {
                  textContext[
                    `nursingIndicator.indicator.circle.${ i }.description`
                  ]
                }
              </span>
            ) */}
            </div>
          )
        })}
    </Styled.IndicatorLegend>
  )
}

IndicatorLegend.propTypes = {
  variant: PropTypes.oneOf(['circle', 'square']),
  withDescription: PropTypes.bool,
}

export default IndicatorLegend
